/* tslint:disable */
/* eslint-disable */
/**
 * Agent Management API
 * CRUD for agents
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Message from an AI.  An `AIMessage` is returned from a chat model as a response to a prompt.  This message represents the output of the model and consists of both the raw output as returned by the model and standardized fields (e.g., tool calls, usage metadata) added by the LangChain framework.
 * @export
 * @interface AIMessage
 */
export interface AIMessage {
    [key: string]: any;

    /**
     * 
     * @type {Content}
     * @memberof AIMessage
     */
    'content': Content;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AIMessage
     */
    'additional_kwargs'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AIMessage
     */
    'response_metadata'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AIMessage
     */
    'type'?: string;
    /**
     * 
     * @type {Name}
     * @memberof AIMessage
     */
    'name'?: Name;
    /**
     * 
     * @type {string}
     * @memberof AIMessage
     */
    'id'?: string;
    /**
     * 
     * @type {Array<ToolCall>}
     * @memberof AIMessage
     */
    'tool_calls'?: Array<ToolCall>;
    /**
     * 
     * @type {Array<InvalidToolCall>}
     * @memberof AIMessage
     */
    'invalid_tool_calls'?: Array<InvalidToolCall>;
    /**
     * 
     * @type {AIMessageUsageMetadata}
     * @memberof AIMessage
     */
    'usage_metadata'?: AIMessageUsageMetadata;
}
/**
 * Message chunk from an AI (yielded when streaming).
 * @export
 * @interface AIMessageChunk
 */
export interface AIMessageChunk {
    [key: string]: any;

    /**
     * 
     * @type {Content}
     * @memberof AIMessageChunk
     */
    'content': Content;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AIMessageChunk
     */
    'additional_kwargs'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AIMessageChunk
     */
    'response_metadata'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AIMessageChunk
     */
    'type'?: string;
    /**
     * 
     * @type {Name}
     * @memberof AIMessageChunk
     */
    'name'?: Name;
    /**
     * 
     * @type {string}
     * @memberof AIMessageChunk
     */
    'id'?: string;
    /**
     * 
     * @type {Array<ToolCall>}
     * @memberof AIMessageChunk
     */
    'tool_calls'?: Array<ToolCall>;
    /**
     * 
     * @type {Array<InvalidToolCall>}
     * @memberof AIMessageChunk
     */
    'invalid_tool_calls'?: Array<InvalidToolCall>;
    /**
     * 
     * @type {AIMessageUsageMetadata}
     * @memberof AIMessageChunk
     */
    'usage_metadata'?: AIMessageUsageMetadata;
    /**
     * 
     * @type {Array<ToolCallChunk>}
     * @memberof AIMessageChunk
     */
    'tool_call_chunks'?: Array<ToolCallChunk>;
    /**
     * 
     * @type {ChunkPosition}
     * @memberof AIMessageChunk
     */
    'chunk_position'?: ChunkPosition;
}
/**
 * 
 * @export
 * @interface AIMessageUsageMetadata
 */
export interface AIMessageUsageMetadata {
    /**
     * 
     * @type {number}
     * @memberof AIMessageUsageMetadata
     */
    'input_tokens': number;
    /**
     * 
     * @type {number}
     * @memberof AIMessageUsageMetadata
     */
    'output_tokens': number;
    /**
     * 
     * @type {number}
     * @memberof AIMessageUsageMetadata
     */
    'total_tokens': number;
    /**
     * 
     * @type {InputTokenDetails}
     * @memberof AIMessageUsageMetadata
     */
    'input_token_details'?: InputTokenDetails;
    /**
     * 
     * @type {OutputTokenDetails}
     * @memberof AIMessageUsageMetadata
     */
    'output_token_details'?: OutputTokenDetails;
}
/**
 * Agent metadata without versions.
 * @export
 * @interface Agent
 */
export interface Agent {
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'id': string;
    /**
     * Globally unique slug for the agent
     * @type {string}
     * @memberof Agent
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'description': string;
    /**
     * 
     * @type {AgentMetadata}
     * @memberof Agent
     */
    'metadata': AgentMetadata;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'folder_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Agent
     */
    'published_versions_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof Agent
     */
    'draft_versions_count'?: number;
}
/**
 * Schema for creating a new agent.
 * @export
 * @interface AgentCreate
 */
export interface AgentCreate {
    /**
     * Globally unique slug for the agent
     * @type {string}
     * @memberof AgentCreate
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof AgentCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentCreate
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof AgentCreate
     */
    'folder_id'?: string | null;
}
/**
 * Response containing an agent.
 * @export
 * @interface AgentCreateResponse
 */
export interface AgentCreateResponse {
    /**
     * 
     * @type {Agent}
     * @memberof AgentCreateResponse
     */
    'agent': Agent;
}
/**
 * Request schema for direct agent API invocation.  Used by external API consumers (e.g., public API, direct client calls). Does not include flow-specific context.
 * @export
 * @interface AgentDirectInvokeRequest
 */
export interface AgentDirectInvokeRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentDirectInvokeRequest
     */
    'agent_id': string;
    /**
     * 
     * @type {AgentVersionId}
     * @memberof AgentDirectInvokeRequest
     */
    'agent_version_id'?: AgentVersionId | null;
    /**
     * 
     * @type {Array<SrcSchemasPublicSchemasChatMessage>}
     * @memberof AgentDirectInvokeRequest
     */
    'messages': Array<SrcSchemasPublicSchemasChatMessage>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgentDirectInvokeRequest
     */
    'file_ids'?: Array<string>;
    /**
     * 
     * @type {InvokeControl}
     * @memberof AgentDirectInvokeRequest
     */
    'control'?: InvokeControl;
    /**
     * 
     * @type {string}
     * @memberof AgentDirectInvokeRequest
     */
    'session_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentDirectInvokeRequest
     */
    'type'?: AgentDirectInvokeRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentDirectInvokeRequest
     */
    'source'?: AgentDirectInvokeRequestSourceEnum;
}

export const AgentDirectInvokeRequestTypeEnum = {
    INVOKE: 'invoke'
} as const;

export type AgentDirectInvokeRequestTypeEnum = typeof AgentDirectInvokeRequestTypeEnum[keyof typeof AgentDirectInvokeRequestTypeEnum];
export const AgentDirectInvokeRequestSourceEnum = {
    API: 'api'
} as const;

export type AgentDirectInvokeRequestSourceEnum = typeof AgentDirectInvokeRequestSourceEnum[keyof typeof AgentDirectInvokeRequestSourceEnum];

/**
 * Request schema for agent invocation from within a flow.  Used by runner when executing agent delegation nodes. Includes additional context about the flow execution environment.
 * @export
 * @interface AgentFlowInvokeRequest
 */
export interface AgentFlowInvokeRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentFlowInvokeRequest
     */
    'agent_id': string;
    /**
     * 
     * @type {AgentVersionId}
     * @memberof AgentFlowInvokeRequest
     */
    'agent_version_id'?: AgentVersionId | null;
    /**
     * 
     * @type {Array<SrcSchemasPublicSchemasChatMessage>}
     * @memberof AgentFlowInvokeRequest
     */
    'messages': Array<SrcSchemasPublicSchemasChatMessage>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgentFlowInvokeRequest
     */
    'file_ids'?: Array<string>;
    /**
     * 
     * @type {InvokeControl}
     * @memberof AgentFlowInvokeRequest
     */
    'control'?: InvokeControl;
    /**
     * 
     * @type {string}
     * @memberof AgentFlowInvokeRequest
     */
    'session_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentFlowInvokeRequest
     */
    'type'?: AgentFlowInvokeRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentFlowInvokeRequest
     */
    'source'?: AgentFlowInvokeRequestSourceEnum;
    /**
     * 
     * @type {FlowRuntimeContext}
     * @memberof AgentFlowInvokeRequest
     */
    'flow_context': FlowRuntimeContext;
}

export const AgentFlowInvokeRequestTypeEnum = {
    INVOKE: 'invoke'
} as const;

export type AgentFlowInvokeRequestTypeEnum = typeof AgentFlowInvokeRequestTypeEnum[keyof typeof AgentFlowInvokeRequestTypeEnum];
export const AgentFlowInvokeRequestSourceEnum = {
    FLOW: 'flow'
} as const;

export type AgentFlowInvokeRequestSourceEnum = typeof AgentFlowInvokeRequestSourceEnum[keyof typeof AgentFlowInvokeRequestSourceEnum];

/**
 * Response containing an agent with version metadata.
 * @export
 * @interface AgentGetResponse
 */
export interface AgentGetResponse {
    /**
     * 
     * @type {AgentWithLastPublished}
     * @memberof AgentGetResponse
     */
    'agent': AgentWithLastPublished;
}
/**
 * Response from agent invocation. Returns the agent\'s message output regardless of invocation method.
 * @export
 * @interface AgentInvokeResponse
 */
export interface AgentInvokeResponse {
    /**
     * 
     * @type {string}
     * @memberof AgentInvokeResponse
     */
    'session_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentInvokeResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentInvokeResponse
     */
    'structured_output'?: { [key: string]: any; } | null;
}
/**
 * Response containing a list of agents.
 * @export
 * @interface AgentListResponse
 */
export interface AgentListResponse {
    /**
     * 
     * @type {Array<Agent>}
     * @memberof AgentListResponse
     */
    'agents': Array<Agent>;
}
/**
 * Metadata for Agent.
 * @export
 * @interface AgentMetadata
 */
export interface AgentMetadata {
    /**
     * 
     * @type {string}
     * @memberof AgentMetadata
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMetadata
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMetadata
     */
    'created_by_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMetadata
     */
    'updated_by_id': string;
}
/**
 * Request schema for playground agent invocation.  Playground invocations use a shared AgentCore runtimeSessionId for pre-warming, while maintaining separate application-level sessions.
 * @export
 * @interface AgentPlaygroundInvokeRequest
 */
export interface AgentPlaygroundInvokeRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'agent_id': string;
    /**
     * 
     * @type {AgentVersionId}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'agent_version_id'?: AgentVersionId | null;
    /**
     * 
     * @type {Array<SrcSchemasPublicSchemasChatMessage>}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'messages': Array<SrcSchemasPublicSchemasChatMessage>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'file_ids'?: Array<string>;
    /**
     * 
     * @type {InvokeControl}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'control'?: InvokeControl;
    /**
     * 
     * @type {string}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'session_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'type'?: AgentPlaygroundInvokeRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'source'?: AgentPlaygroundInvokeRequestSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentPlaygroundInvokeRequest
     */
    'playground_id': string;
}

export const AgentPlaygroundInvokeRequestTypeEnum = {
    INVOKE: 'invoke'
} as const;

export type AgentPlaygroundInvokeRequestTypeEnum = typeof AgentPlaygroundInvokeRequestTypeEnum[keyof typeof AgentPlaygroundInvokeRequestTypeEnum];
export const AgentPlaygroundInvokeRequestSourceEnum = {
    PLAYGROUND: 'playground'
} as const;

export type AgentPlaygroundInvokeRequestSourceEnum = typeof AgentPlaygroundInvokeRequestSourceEnum[keyof typeof AgentPlaygroundInvokeRequestSourceEnum];

/**
 * Schema for updating an existing agent.  All mutable fields must be provided. Immutable fields (id, slug, created_at, created_by_id) are preserved from the existing agent.
 * @export
 * @interface AgentUpdate
 */
export interface AgentUpdate {
    /**
     * 
     * @type {string}
     * @memberof AgentUpdate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentUpdate
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof AgentUpdate
     */
    'folder_id'?: string | null;
}
/**
 * Response containing an updated agent.
 * @export
 * @interface AgentUpdateResponse
 */
export interface AgentUpdateResponse {
    /**
     * 
     * @type {Agent}
     * @memberof AgentUpdateResponse
     */
    'agent': Agent;
}
/**
 * Agent version summary without full configuration.
 * @export
 * @interface AgentVersion
 */
export interface AgentVersion {
    /**
     * 
     * @type {string}
     * @memberof AgentVersion
     */
    'id': string;
    /**
     * Optimistic locking version tag
     * @type {string}
     * @memberof AgentVersion
     */
    'etag': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersion
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersion
     */
    'description': string;
    /**
     * Reference to parent Agent
     * @type {string}
     * @memberof AgentVersion
     */
    'agent_id': string;
    /**
     * 
     * @type {AgentVersionStatus}
     * @memberof AgentVersion
     */
    'status': AgentVersionStatus;
    /**
     * 
     * @type {AgentVersionMetadata}
     * @memberof AgentVersion
     */
    'metadata': AgentVersionMetadata;
    /**
     * 
     * @type {AgentVersionConfigurationOutput}
     * @memberof AgentVersion
     */
    'configuration': AgentVersionConfigurationOutput;
}


/**
 * Agent version configuration.
 * @export
 * @interface AgentVersionConfigurationInput
 */
export interface AgentVersionConfigurationInput {
    /**
     * 
     * @type {AgentVersionLLMConfig}
     * @memberof AgentVersionConfigurationInput
     */
    'model_config': AgentVersionLLMConfig;
    /**
     * 
     * @type {Array<AgentVersionConfigurationInputToolsInner>}
     * @memberof AgentVersionConfigurationInput
     */
    'tools'?: Array<AgentVersionConfigurationInputToolsInner>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentVersionConfigurationInput
     */
    'input_schema'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentVersionConfigurationInput
     */
    'output_schema'?: { [key: string]: any; } | null;
    /**
     * Execution configuration for runtime limits and behavior
     * @type {ExecutionConfig}
     * @memberof AgentVersionConfigurationInput
     */
    'execution_config'?: ExecutionConfig;
}
/**
 * 
 * @export
 * @interface AgentVersionConfigurationInputToolsInner
 */
export interface AgentVersionConfigurationInputToolsInner {
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'type'?: AgentVersionConfigurationInputToolsInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'input_schema': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'output_type'?: AgentVersionConfigurationInputToolsInnerOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'output_schema': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'flow_slug': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'flow_version_id': string;
    /**
     * 
     * @type {FlowToolExecutionMode}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'tool_flow_execution_mode'?: FlowToolExecutionMode;
    /**
     * 
     * @type {MetadataOverlay}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'input_schema_metadata_overlay'?: MetadataOverlay;
    /**
     * 
     * @type {MetadataOverlay}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'output_schema_metadata_overlay'?: MetadataOverlay;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'model_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationInputToolsInner
     */
    'prompt'?: string;
}

export const AgentVersionConfigurationInputToolsInnerTypeEnum = {
    FLOW: 'flow',
    ANALYZE_DOCUMENT: 'analyze_document',
    SLEEP: 'sleep',
    RANDOM_NUMBER: 'random_number',
    ECHO: 'echo'
} as const;

export type AgentVersionConfigurationInputToolsInnerTypeEnum = typeof AgentVersionConfigurationInputToolsInnerTypeEnum[keyof typeof AgentVersionConfigurationInputToolsInnerTypeEnum];
export const AgentVersionConfigurationInputToolsInnerOutputTypeEnum = {
    JSON: 'json'
} as const;

export type AgentVersionConfigurationInputToolsInnerOutputTypeEnum = typeof AgentVersionConfigurationInputToolsInnerOutputTypeEnum[keyof typeof AgentVersionConfigurationInputToolsInnerOutputTypeEnum];

/**
 * Agent version configuration.
 * @export
 * @interface AgentVersionConfigurationOutput
 */
export interface AgentVersionConfigurationOutput {
    /**
     * 
     * @type {AgentVersionLLMConfig}
     * @memberof AgentVersionConfigurationOutput
     */
    'model_config': AgentVersionLLMConfig;
    /**
     * 
     * @type {Array<AgentVersionConfigurationOutputToolsInner>}
     * @memberof AgentVersionConfigurationOutput
     */
    'tools'?: Array<AgentVersionConfigurationOutputToolsInner>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentVersionConfigurationOutput
     */
    'input_schema'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentVersionConfigurationOutput
     */
    'output_schema'?: { [key: string]: any; } | null;
    /**
     * Execution configuration for runtime limits and behavior
     * @type {ExecutionConfig}
     * @memberof AgentVersionConfigurationOutput
     */
    'execution_config'?: ExecutionConfig;
}
/**
 * 
 * @export
 * @interface AgentVersionConfigurationOutputToolsInner
 */
export interface AgentVersionConfigurationOutputToolsInner {
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'type'?: AgentVersionConfigurationOutputToolsInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'input_schema': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'output_type'?: AgentVersionConfigurationOutputToolsInnerOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'output_schema': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'flow_slug': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'flow_version_id': string;
    /**
     * 
     * @type {FlowToolExecutionMode}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'tool_flow_execution_mode'?: FlowToolExecutionMode;
    /**
     * 
     * @type {MetadataOverlay}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'input_schema_metadata_overlay'?: MetadataOverlay;
    /**
     * 
     * @type {MetadataOverlay}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'output_schema_metadata_overlay'?: MetadataOverlay;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'model_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionConfigurationOutputToolsInner
     */
    'prompt'?: string;
}

export const AgentVersionConfigurationOutputToolsInnerTypeEnum = {
    FLOW: 'flow',
    ANALYZE_DOCUMENT: 'analyze_document',
    SLEEP: 'sleep',
    RANDOM_NUMBER: 'random_number',
    ECHO: 'echo'
} as const;

export type AgentVersionConfigurationOutputToolsInnerTypeEnum = typeof AgentVersionConfigurationOutputToolsInnerTypeEnum[keyof typeof AgentVersionConfigurationOutputToolsInnerTypeEnum];
export const AgentVersionConfigurationOutputToolsInnerOutputTypeEnum = {
    JSON: 'json'
} as const;

export type AgentVersionConfigurationOutputToolsInnerOutputTypeEnum = typeof AgentVersionConfigurationOutputToolsInnerOutputTypeEnum[keyof typeof AgentVersionConfigurationOutputToolsInnerOutputTypeEnum];

/**
 * Schema for creating a new agent version.  Either configuration or source_version_id must be provided, but not both.
 * @export
 * @interface AgentVersionCreate
 */
export interface AgentVersionCreate {
    /**
     * 
     * @type {string}
     * @memberof AgentVersionCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionCreate
     */
    'description': string;
    /**
     * 
     * @type {AgentVersionConfigurationInput}
     * @memberof AgentVersionCreate
     */
    'configuration'?: AgentVersionConfigurationInput | null;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionCreate
     */
    'source_version_id'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentVersionId
 */
export interface AgentVersionId {
}
/**
 * LLM configuration.
 * @export
 * @interface AgentVersionLLMConfig
 */
export interface AgentVersionLLMConfig {
    /**
     * Model identifier
     * @type {Model}
     * @memberof AgentVersionLLMConfig
     */
    'model': Model;
    /**
     * System prompt for the model
     * @type {string}
     * @memberof AgentVersionLLMConfig
     */
    'system_prompt': string;
    /**
     * Sampling temperature for the model
     * @type {number}
     * @memberof AgentVersionLLMConfig
     */
    'temperature': number;
}


/**
 * Response containing a list of agent versions.
 * @export
 * @interface AgentVersionListResponse
 */
export interface AgentVersionListResponse {
    /**
     * 
     * @type {Array<AgentVersion>}
     * @memberof AgentVersionListResponse
     */
    'versions': Array<AgentVersion>;
}
/**
 * Metadata for AgentVersion.
 * @export
 * @interface AgentVersionMetadata
 */
export interface AgentVersionMetadata {
    /**
     * 
     * @type {string}
     * @memberof AgentVersionMetadata
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionMetadata
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionMetadata
     */
    'created_by_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionMetadata
     */
    'updated_by_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionMetadata
     */
    'published_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionMetadata
     */
    'published_by_id'?: string | null;
}
/**
 * Response containing an agent version.
 * @export
 * @interface AgentVersionResponse
 */
export interface AgentVersionResponse {
    /**
     * 
     * @type {AgentVersion}
     * @memberof AgentVersionResponse
     */
    'agent_version': AgentVersion;
}
/**
 * Status of an agent version.
 * @export
 * @enum {string}
 */

export const AgentVersionStatus = {
    PUBLISHED: 'published',
    DRAFT: 'draft'
} as const;

export type AgentVersionStatus = typeof AgentVersionStatus[keyof typeof AgentVersionStatus];


/**
 * Schema for updating an existing agent version.
 * @export
 * @interface AgentVersionUpdate
 */
export interface AgentVersionUpdate {
    /**
     * 
     * @type {string}
     * @memberof AgentVersionUpdate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentVersionUpdate
     */
    'description': string;
    /**
     * 
     * @type {AgentVersionConfigurationInput}
     * @memberof AgentVersionUpdate
     */
    'configuration': AgentVersionConfigurationInput;
}
/**
 * Agent with optional last published version ID.  Used as the return type for get_agent to include the latest published version.
 * @export
 * @interface AgentWithLastPublished
 */
export interface AgentWithLastPublished {
    /**
     * 
     * @type {string}
     * @memberof AgentWithLastPublished
     */
    'id': string;
    /**
     * Globally unique slug for the agent
     * @type {string}
     * @memberof AgentWithLastPublished
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof AgentWithLastPublished
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentWithLastPublished
     */
    'description': string;
    /**
     * 
     * @type {AgentMetadata}
     * @memberof AgentWithLastPublished
     */
    'metadata': AgentMetadata;
    /**
     * 
     * @type {string}
     * @memberof AgentWithLastPublished
     */
    'folder_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentWithLastPublished
     */
    'published_versions_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentWithLastPublished
     */
    'draft_versions_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentWithLastPublished
     */
    'latest_published_version_id'?: string | null;
}
/**
 * 
 * @export
 * @interface AnalyzeDocumentToolConfig
 */
export interface AnalyzeDocumentToolConfig {
    /**
     * 
     * @type {string}
     * @memberof AnalyzeDocumentToolConfig
     */
    'type'?: AnalyzeDocumentToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeDocumentToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeDocumentToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AnalyzeDocumentToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AnalyzeDocumentToolConfig
     */
    'output_type'?: AnalyzeDocumentToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AnalyzeDocumentToolConfig
     */
    'output_schema': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AnalyzeDocumentToolConfig
     */
    'model_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeDocumentToolConfig
     */
    'prompt'?: string | null;
}

export const AnalyzeDocumentToolConfigTypeEnum = {
    ANALYZE_DOCUMENT: 'analyze_document'
} as const;

export type AnalyzeDocumentToolConfigTypeEnum = typeof AnalyzeDocumentToolConfigTypeEnum[keyof typeof AnalyzeDocumentToolConfigTypeEnum];
export const AnalyzeDocumentToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type AnalyzeDocumentToolConfigOutputTypeEnum = typeof AnalyzeDocumentToolConfigOutputTypeEnum[keyof typeof AnalyzeDocumentToolConfigOutputTypeEnum];

/**
 * When triggered from an API call.
 * @export
 * @interface ApiTrigger
 */
export interface ApiTrigger {
    /**
     * 
     * @type {string}
     * @memberof ApiTrigger
     */
    'source_type'?: ApiTriggerSourceTypeEnum;
}

export const ApiTriggerSourceTypeEnum = {
    API: 'api'
} as const;

export type ApiTriggerSourceTypeEnum = typeof ApiTriggerSourceTypeEnum[keyof typeof ApiTriggerSourceTypeEnum];

/**
 * 
 * @export
 * @interface Args
 */
export interface Args {
}
/**
 * When triggered from a case.
 * @export
 * @interface CaseTrigger
 */
export interface CaseTrigger {
    /**
     * 
     * @type {string}
     * @memberof CaseTrigger
     */
    'source_type'?: CaseTriggerSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseTrigger
     */
    'case_id': string;
}

export const CaseTriggerSourceTypeEnum = {
    CASE: 'case'
} as const;

export type CaseTriggerSourceTypeEnum = typeof CaseTriggerSourceTypeEnum[keyof typeof CaseTriggerSourceTypeEnum];

/**
 * Chat Message chunk.
 * @export
 * @interface ChatMessageChunk
 */
export interface ChatMessageChunk {
    [key: string]: any;

    /**
     * 
     * @type {Content}
     * @memberof ChatMessageChunk
     */
    'content': Content;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ChatMessageChunk
     */
    'additional_kwargs'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ChatMessageChunk
     */
    'response_metadata'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ChatMessageChunk
     */
    'type'?: string;
    /**
     * 
     * @type {Name}
     * @memberof ChatMessageChunk
     */
    'name'?: Name;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageChunk
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageChunk
     */
    'role': string;
}
/**
 * 
 * @export
 * @interface ChunkPosition
 */
export interface ChunkPosition {
}
/**
 * 
 * @export
 * @interface Content
 */
export interface Content {
}
/**
 * 
 * @export
 * @interface ContentAnyOfInner
 */
export interface ContentAnyOfInner {
}
/**
 * 
 * @export
 * @interface Data
 */
export interface Data {
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'agent_id': string;
    /**
     * 
     * @type {AgentVersionId}
     * @memberof Data
     */
    'agent_version_id'?: AgentVersionId | null;
    /**
     * 
     * @type {Array<SrcSchemasPublicSchemasChatMessage>}
     * @memberof Data
     */
    'messages': Array<SrcSchemasPublicSchemasChatMessage>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Data
     */
    'file_ids'?: Array<string>;
    /**
     * 
     * @type {InvokeControl}
     * @memberof Data
     */
    'control'?: InvokeControl;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'session_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'type'?: DataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'source'?: DataSourceEnum;
    /**
     * 
     * @type {FlowRuntimeContext}
     * @memberof Data
     */
    'flow_context': FlowRuntimeContext;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'playground_id': string;
}

export const DataTypeEnum = {
    INVOKE: 'invoke'
} as const;

export type DataTypeEnum = typeof DataTypeEnum[keyof typeof DataTypeEnum];
export const DataSourceEnum = {
    PLAYGROUND: 'playground'
} as const;

export type DataSourceEnum = typeof DataSourceEnum[keyof typeof DataSourceEnum];

/**
 * Tool that echoes back its input as output. Input and output schemas are user-defined and must match.
 * @export
 * @interface EchoToolConfig
 */
export interface EchoToolConfig {
    /**
     * 
     * @type {string}
     * @memberof EchoToolConfig
     */
    'type'?: EchoToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EchoToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EchoToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof EchoToolConfig
     */
    'input_schema': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof EchoToolConfig
     */
    'output_type'?: EchoToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof EchoToolConfig
     */
    'output_schema': { [key: string]: any; };
}

export const EchoToolConfigTypeEnum = {
    ECHO: 'echo'
} as const;

export type EchoToolConfigTypeEnum = typeof EchoToolConfigTypeEnum[keyof typeof EchoToolConfigTypeEnum];
export const EchoToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type EchoToolConfigOutputTypeEnum = typeof EchoToolConfigOutputTypeEnum[keyof typeof EchoToolConfigOutputTypeEnum];

/**
 * Taktile execution environment.
 * @export
 * @enum {string}
 */

export const Environment = {
    PRODUCTION: 'production',
    SANDBOX: 'sandbox'
} as const;

export type Environment = typeof Environment[keyof typeof Environment];


/**
 * Execution configuration for agent runtime limits and behavior.  All fields are optional - if not provided, defaults are used at runtime.  IMPORTANT: Don\'t use raw fields directly (optional user-defined values). Always use properties (e.g., `max_steps_per_session`) with default fallback.
 * @export
 * @interface ExecutionConfig
 */
export interface ExecutionConfig {
    /**
     * 
     * @type {number}
     * @memberof ExecutionConfig
     */
    'session_max_lifetime_seconds'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExecutionConfig
     */
    'invocation_max_runtime_seconds'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExecutionConfig
     */
    'max_steps_per_session'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExecutionConfig
     */
    'tool_http_timeout_seconds'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExecutionConfig
     */
    'tool_retry_max_retries'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExecutionConfig
     */
    'tool_loop_repetition_threshold'?: number | null;
}
/**
 * Synchronous invocation is used for SSE streaming.
 * @export
 * @enum {string}
 */

export const ExecutionMode = {
    SYNC: 'sync',
    ASYNC: 'async'
} as const;

export type ExecutionMode = typeof ExecutionMode[keyof typeof ExecutionMode];


/**
 * 
 * @export
 * @interface FlowId
 */
export interface FlowId {
}
/**
 * Context information about the flow execution environment.  Provides metadata about the flow, decision, and execution environment when an agent is invoked from within a flow.
 * @export
 * @interface FlowRuntimeContext
 */
export interface FlowRuntimeContext {
    /**
     * 
     * @type {FlowId}
     * @memberof FlowRuntimeContext
     */
    'flow_id': FlowId;
    /**
     * 
     * @type {string}
     * @memberof FlowRuntimeContext
     */
    'flow_slug': string;
    /**
     * 
     * @type {string}
     * @memberof FlowRuntimeContext
     */
    'flow_version_name'?: string | null;
    /**
     * 
     * @type {FlowVersionId}
     * @memberof FlowRuntimeContext
     */
    'flow_version_id'?: FlowVersionId | null;
    /**
     * 
     * @type {string}
     * @memberof FlowRuntimeContext
     */
    'decision_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlowRuntimeContext
     */
    'node_id'?: string | null;
    /**
     * 
     * @type {Environment}
     * @memberof FlowRuntimeContext
     */
    'environment'?: Environment;
}


/**
 * Configuration for a flow tool that calls a Taktile flow.
 * @export
 * @interface FlowToolConfigInput
 */
export interface FlowToolConfigInput {
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigInput
     */
    'type'?: FlowToolConfigInputTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigInput
     */
    'description'?: string;
    /**
     * 
     * @type {}
     * @memberof FlowToolConfigInput
     */
    'input_schema'?:  | null;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigInput
     */
    'output_type'?: FlowToolConfigInputOutputTypeEnum;
    /**
     * 
     * @type {}
     * @memberof FlowToolConfigInput
     */
    'output_schema'?:  | null;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigInput
     */
    'flow_slug': string;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigInput
     */
    'flow_version_id': string;
    /**
     * 
     * @type {FlowToolExecutionMode}
     * @memberof FlowToolConfigInput
     */
    'tool_flow_execution_mode'?: FlowToolExecutionMode;
    /**
     * 
     * @type {MetadataOverlay}
     * @memberof FlowToolConfigInput
     */
    'input_schema_metadata_overlay'?: MetadataOverlay | null;
    /**
     * 
     * @type {MetadataOverlay}
     * @memberof FlowToolConfigInput
     */
    'output_schema_metadata_overlay'?: MetadataOverlay | null;
}

export const FlowToolConfigInputTypeEnum = {
    FLOW: 'flow'
} as const;

export type FlowToolConfigInputTypeEnum = typeof FlowToolConfigInputTypeEnum[keyof typeof FlowToolConfigInputTypeEnum];
export const FlowToolConfigInputOutputTypeEnum = {
    JSON: 'json'
} as const;

export type FlowToolConfigInputOutputTypeEnum = typeof FlowToolConfigInputOutputTypeEnum[keyof typeof FlowToolConfigInputOutputTypeEnum];

/**
 * Configuration for a flow tool that calls a Taktile flow.
 * @export
 * @interface FlowToolConfigOutput
 */
export interface FlowToolConfigOutput {
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigOutput
     */
    'type'?: FlowToolConfigOutputTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigOutput
     */
    'description'?: string;
    /**
     * 
     * @type {}
     * @memberof FlowToolConfigOutput
     */
    'input_schema'?:  | null;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigOutput
     */
    'output_type'?: FlowToolConfigOutputOutputTypeEnum;
    /**
     * 
     * @type {}
     * @memberof FlowToolConfigOutput
     */
    'output_schema'?:  | null;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigOutput
     */
    'flow_slug': string;
    /**
     * 
     * @type {string}
     * @memberof FlowToolConfigOutput
     */
    'flow_version_id': string;
    /**
     * 
     * @type {FlowToolExecutionMode}
     * @memberof FlowToolConfigOutput
     */
    'tool_flow_execution_mode'?: FlowToolExecutionMode;
    /**
     * 
     * @type {MetadataOverlay}
     * @memberof FlowToolConfigOutput
     */
    'input_schema_metadata_overlay'?: MetadataOverlay | null;
    /**
     * 
     * @type {MetadataOverlay}
     * @memberof FlowToolConfigOutput
     */
    'output_schema_metadata_overlay'?: MetadataOverlay | null;
}

export const FlowToolConfigOutputTypeEnum = {
    FLOW: 'flow'
} as const;

export type FlowToolConfigOutputTypeEnum = typeof FlowToolConfigOutputTypeEnum[keyof typeof FlowToolConfigOutputTypeEnum];
export const FlowToolConfigOutputOutputTypeEnum = {
    JSON: 'json'
} as const;

export type FlowToolConfigOutputOutputTypeEnum = typeof FlowToolConfigOutputOutputTypeEnum[keyof typeof FlowToolConfigOutputOutputTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const FlowToolExecutionMode = {
    SYNC: 'sync',
    ASYNC: 'async'
} as const;

export type FlowToolExecutionMode = typeof FlowToolExecutionMode[keyof typeof FlowToolExecutionMode];


/**
 * When triggered from a flow.
 * @export
 * @interface FlowTrigger
 */
export interface FlowTrigger {
    /**
     * 
     * @type {string}
     * @memberof FlowTrigger
     */
    'source_type'?: FlowTriggerSourceTypeEnum;
    /**
     * 
     * @type {FlowRuntimeContext}
     * @memberof FlowTrigger
     */
    'flow_context': FlowRuntimeContext;
}

export const FlowTriggerSourceTypeEnum = {
    FLOW: 'flow'
} as const;

export type FlowTriggerSourceTypeEnum = typeof FlowTriggerSourceTypeEnum[keyof typeof FlowTriggerSourceTypeEnum];

/**
 * 
 * @export
 * @interface FlowVersionId
 */
export interface FlowVersionId {
}
/**
 * Message for passing the result of executing a tool back to a model.  `FunctionMessage` are an older version of the `ToolMessage` schema, and do not contain the `tool_call_id` field.  The `tool_call_id` field is used to associate the tool call request with the tool call response. Useful in situations where a chat model is able to request multiple tool calls in parallel.
 * @export
 * @interface FunctionMessage
 */
export interface FunctionMessage {
    [key: string]: any;

    /**
     * 
     * @type {Content}
     * @memberof FunctionMessage
     */
    'content': Content;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FunctionMessage
     */
    'additional_kwargs'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FunctionMessage
     */
    'response_metadata'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof FunctionMessage
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionMessage
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FunctionMessage
     */
    'id'?: string;
}
/**
 * Function Message chunk.
 * @export
 * @interface FunctionMessageChunk
 */
export interface FunctionMessageChunk {
    [key: string]: any;

    /**
     * 
     * @type {Content}
     * @memberof FunctionMessageChunk
     */
    'content': Content;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FunctionMessageChunk
     */
    'additional_kwargs'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FunctionMessageChunk
     */
    'response_metadata'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof FunctionMessageChunk
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionMessageChunk
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FunctionMessageChunk
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * Message from the user.  A `HumanMessage` is a message that is passed in from a user to the model.  Example:     ```python     from langchain_core.messages import HumanMessage, SystemMessage      messages = [         SystemMessage(content=\"You are a helpful assistant! Your name is Bob.\"),         HumanMessage(content=\"What is your name?\"),     ]      # Instantiate a chat model and invoke it with the messages     model = ...     print(model.invoke(messages))     ```
 * @export
 * @interface HumanMessage
 */
export interface HumanMessage {
    [key: string]: any;

    /**
     * 
     * @type {Content}
     * @memberof HumanMessage
     */
    'content': Content;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof HumanMessage
     */
    'additional_kwargs'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof HumanMessage
     */
    'response_metadata'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof HumanMessage
     */
    'type'?: string;
    /**
     * 
     * @type {Name}
     * @memberof HumanMessage
     */
    'name'?: Name;
    /**
     * 
     * @type {string}
     * @memberof HumanMessage
     */
    'id'?: string;
}
/**
 * Human Message chunk.
 * @export
 * @interface HumanMessageChunk
 */
export interface HumanMessageChunk {
    [key: string]: any;

    /**
     * 
     * @type {Content}
     * @memberof HumanMessageChunk
     */
    'content': Content;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof HumanMessageChunk
     */
    'additional_kwargs'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof HumanMessageChunk
     */
    'response_metadata'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof HumanMessageChunk
     */
    'type'?: string;
    /**
     * 
     * @type {Name}
     * @memberof HumanMessageChunk
     */
    'name'?: Name;
    /**
     * 
     * @type {string}
     * @memberof HumanMessageChunk
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface Id
 */
export interface Id {
}
/**
 * 
 * @export
 * @interface Index
 */
export interface Index {
}
/**
 * Breakdown of input token counts.  Does *not* need to sum to full input token count. Does *not* need to have all keys.  Example:     ```python     {         \"audio\": 10,         \"cache_creation\": 200,         \"cache_read\": 100,     }     ```  May also hold extra provider-specific keys.  !!! version-added \"Added in `langchain-core` 0.3.9\"
 * @export
 * @interface InputTokenDetails
 */
export interface InputTokenDetails {
    [key: string]: any;

    /**
     * 
     * @type {number}
     * @memberof InputTokenDetails
     */
    'audio'?: number;
    /**
     * 
     * @type {number}
     * @memberof InputTokenDetails
     */
    'cache_creation'?: number;
    /**
     * 
     * @type {number}
     * @memberof InputTokenDetails
     */
    'cache_read'?: number;
}
/**
 * Allowance for errors made by LLM.  Here we add an `error` key to surface errors made during generation (e.g., invalid JSON arguments.)
 * @export
 * @interface InvalidToolCall
 */
export interface InvalidToolCall {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof InvalidToolCall
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof InvalidToolCall
     */
    'id': string;
    /**
     * 
     * @type {Name}
     * @memberof InvalidToolCall
     */
    'name': Name;
    /**
     * 
     * @type {Args}
     * @memberof InvalidToolCall
     */
    'args': Args;
    /**
     * 
     * @type {Error}
     * @memberof InvalidToolCall
     */
    'error': Error;
    /**
     * 
     * @type {Index}
     * @memberof InvalidToolCall
     */
    'index'?: Index;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof InvalidToolCall
     */
    'extras'?: { [key: string]: any; };
}
/**
 * Control parameters for agent execution.
 * @export
 * @interface InvokeControl
 */
export interface InvokeControl {
    /**
     * 
     * @type {ExecutionMode}
     * @memberof InvokeControl
     */
    'execution_mode'?: ExecutionMode;
    /**
     * 
     * @type {Environment}
     * @memberof InvokeControl
     */
    'environment'?: Environment;
}


/**
 * Message that can be assigned an arbitrary speaker (i.e. role).
 * @export
 * @interface LangchainCoreMessagesChatChatMessage
 */
export interface LangchainCoreMessagesChatChatMessage {
    [key: string]: any;

    /**
     * 
     * @type {Content}
     * @memberof LangchainCoreMessagesChatChatMessage
     */
    'content': Content;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof LangchainCoreMessagesChatChatMessage
     */
    'additional_kwargs'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof LangchainCoreMessagesChatChatMessage
     */
    'response_metadata'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof LangchainCoreMessagesChatChatMessage
     */
    'type'?: string;
    /**
     * 
     * @type {Name}
     * @memberof LangchainCoreMessagesChatChatMessage
     */
    'name'?: Name;
    /**
     * 
     * @type {string}
     * @memberof LangchainCoreMessagesChatChatMessage
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LangchainCoreMessagesChatChatMessage
     */
    'role': string;
}
/**
 * Overlay for enriching a flow\'s JSONSchema (input or output) with agent-specific metadata.  Maps property names to their metadata overlays. During schema resolution, each property\'s overlay is merged into the corresponding property definition from the base flow schema.  We currently only allow overlays on top-level properties, not nested ones.  Note: Schema-level title and description are provided via the base tool config fields (name, description), not here.  Example:     Given a flow with schema:     {         \"properties\": {             \"customer_id\": {\"type\": \"string\"},             \"amount\": {\"type\": \"number\"}         }     }      An overlay might be:     {         \"properties\": {             \"customer_id\": {                 \"description\": \"The unique customer identifier from the CRM\"             },             \"amount\": {                 \"description\": \"Transaction amount in USD\"             }         }     }
 * @export
 * @interface MetadataOverlay
 */
export interface MetadataOverlay {
    /**
     * 
     * @type {{ [key: string]: PropertyMetadataOverlay; }}
     * @memberof MetadataOverlay
     */
    'properties': { [key: string]: PropertyMetadataOverlay; };
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Model = {
    CLAUDE_4_5_SONNET: 'claude-4-5-sonnet',
    CLAUDE_3_7_SONNET: 'claude-3-7-sonnet',
    CLAUDE_3_5_SONNET_V2: 'claude-3-5-sonnet-v2',
    CLAUDE_3_5_SONNET: 'claude-3-5-sonnet',
    CLAUDE_3_SONNET: 'claude-3-sonnet',
    CLAUDE_4_5_HAIKU: 'claude-4-5-haiku',
    CLAUDE_3_5_HAIKU: 'claude-3-5-haiku',
    CLAUDE_3_HAIKU: 'claude-3-haiku',
    DEEPSEEK_R1: 'deepseek-r1',
    AMAZON_NOVA_PRO: 'amazon-nova-pro',
    GPT_5: 'gpt-5',
    GPT_5_MINI: 'gpt-5-mini',
    GPT_4_1: 'gpt-4-1',
    GPT_4_1_MINI: 'gpt-4-1-mini',
    GEMINI_2_5_PRO: 'gemini-2-5-pro',
    GEMINI_2_5_FLASH: 'gemini-2-5-flash'
} as const;

export type Model = typeof Model[keyof typeof Model];


/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
}
/**
 * 
 * @export
 * @interface Name
 */
export interface Name {
}
/**
 * Breakdown of output token counts.  Does *not* need to sum to full output token count. Does *not* need to have all keys.  Example:     ```python     {         \"audio\": 10,         \"reasoning\": 200,     }     ```  May also hold extra provider-specific keys.  !!! version-added \"Added in `langchain-core` 0.3.9\"
 * @export
 * @interface OutputTokenDetails
 */
export interface OutputTokenDetails {
    [key: string]: any;

    /**
     * 
     * @type {number}
     * @memberof OutputTokenDetails
     */
    'audio'?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputTokenDetails
     */
    'reasoning'?: number;
}
/**
 * Request to pre-warm a playground container for an agent version.
 * @export
 * @interface PlaygroundPingRequest
 */
export interface PlaygroundPingRequest {
    /**
     * 
     * @type {string}
     * @memberof PlaygroundPingRequest
     */
    'type'?: PlaygroundPingRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PlaygroundPingRequest
     */
    'agent_id': string;
    /**
     * 
     * @type {AgentVersionId}
     * @memberof PlaygroundPingRequest
     */
    'agent_version_id'?: AgentVersionId | null;
    /**
     * 
     * @type {string}
     * @memberof PlaygroundPingRequest
     */
    'playground_id': string;
}

export const PlaygroundPingRequestTypeEnum = {
    PING: 'ping'
} as const;

export type PlaygroundPingRequestTypeEnum = typeof PlaygroundPingRequestTypeEnum[keyof typeof PlaygroundPingRequestTypeEnum];

/**
 * Response from playground ping.
 * @export
 * @interface PlaygroundPingResponse
 */
export interface PlaygroundPingResponse {
    /**
     * 
     * @type {string}
     * @memberof PlaygroundPingResponse
     */
    'type'?: PlaygroundPingResponseTypeEnum;
}

export const PlaygroundPingResponseTypeEnum = {
    PONG: 'pong'
} as const;

export type PlaygroundPingResponseTypeEnum = typeof PlaygroundPingResponseTypeEnum[keyof typeof PlaygroundPingResponseTypeEnum];

/**
 * When triggered from the playground.
 * @export
 * @interface PlaygroundTrigger
 */
export interface PlaygroundTrigger {
    /**
     * 
     * @type {string}
     * @memberof PlaygroundTrigger
     */
    'source_type'?: PlaygroundTriggerSourceTypeEnum;
}

export const PlaygroundTriggerSourceTypeEnum = {
    PLAYGROUND: 'playground'
} as const;

export type PlaygroundTriggerSourceTypeEnum = typeof PlaygroundTriggerSourceTypeEnum[keyof typeof PlaygroundTriggerSourceTypeEnum];

/**
 * Metadata overlay for a single JSONSchema property.  Used to enrich a flow\'s input schema with agent-specific metadata that helps the agent understand how to populate the property.
 * @export
 * @interface PropertyMetadataOverlay
 */
export interface PropertyMetadataOverlay {
    /**
     * 
     * @type {string}
     * @memberof PropertyMetadataOverlay
     */
    'description'?: string | null;
}
/**
 * Tool that generates a random number in a specified range.
 * @export
 * @interface RandomNumberToolConfig
 */
export interface RandomNumberToolConfig {
    /**
     * 
     * @type {string}
     * @memberof RandomNumberToolConfig
     */
    'type'?: RandomNumberToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RandomNumberToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RandomNumberToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RandomNumberToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof RandomNumberToolConfig
     */
    'output_type'?: RandomNumberToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RandomNumberToolConfig
     */
    'output_schema'?: { [key: string]: any; };
}

export const RandomNumberToolConfigTypeEnum = {
    RANDOM_NUMBER: 'random_number'
} as const;

export type RandomNumberToolConfigTypeEnum = typeof RandomNumberToolConfigTypeEnum[keyof typeof RandomNumberToolConfigTypeEnum];
export const RandomNumberToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type RandomNumberToolConfigOutputTypeEnum = typeof RandomNumberToolConfigOutputTypeEnum[keyof typeof RandomNumberToolConfigOutputTypeEnum];

/**
 * API response for GET /sessions/{session_id}.  Standalone response model with explicit fields, allowing the API to evolve independently of the internal Session model.
 * @export
 * @interface SessionResponse
 */
export interface SessionResponse {
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'session_id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'agent_id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'agent_version_id': string;
    /**
     * 
     * @type {Environment}
     * @memberof SessionResponse
     */
    'environment': Environment;
    /**
     * 
     * @type {SessionStatus}
     * @memberof SessionResponse
     */
    'status': SessionStatus;
    /**
     * 
     * @type {TerminationReason}
     * @memberof SessionResponse
     */
    'termination_reason'?: TerminationReason | null;
    /**
     * 
     * @type {Trigger}
     * @memberof SessionResponse
     */
    'trigger': Trigger;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'started_at': string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'finished_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof SessionResponse
     */
    'total_tokens'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionResponse
     */
    'total_cost_usd'?: number;
    /**
     * 
     * @type {SessionResultResponse}
     * @memberof SessionResponse
     */
    'result'?: SessionResultResponse | null;
    /**
     * 
     * @type {Array<SessionResponseMessagesInner>}
     * @memberof SessionResponse
     */
    'messages'?: Array<SessionResponseMessagesInner> | null;
}


/**
 * @type SessionResponseMessagesInner
 * @export
 */
export type SessionResponseMessagesInner = AIMessage | AIMessageChunk | ChatMessageChunk | FunctionMessage | FunctionMessageChunk | HumanMessage | HumanMessageChunk | LangchainCoreMessagesChatChatMessage | SystemMessage | SystemMessageChunk | ToolMessage | ToolMessageChunk;

/**
 * API response schema for session result.
 * @export
 * @interface SessionResultResponse
 */
export interface SessionResultResponse {
    /**
     * 
     * @type {string}
     * @memberof SessionResultResponse
     */
    'text'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SessionResultResponse
     */
    'structured_output'?: { [key: string]: any; } | null;
}
/**
 * Defines the lifecycle of an agent session.  Active states: - running: Agent is currently executing in AgentCore - paused: Agent is paused (async dependency or HITL)  Terminal states: - success: Completed successfully with final output - failed: Irrecoverable error (with termination_reason) - cancelled: Manually cancelled by user/API or programmatically
 * @export
 * @enum {string}
 */

export const SessionStatus = {
    RUNNING: 'running',
    PAUSED: 'paused',
    SUCCESS: 'success',
    FAILED: 'failed',
    CANCELLED: 'cancelled'
} as const;

export type SessionStatus = typeof SessionStatus[keyof typeof SessionStatus];


/**
 * Tool that sleeps for a specified duration. Useful for testing async behavior.
 * @export
 * @interface SleepToolConfig
 */
export interface SleepToolConfig {
    /**
     * 
     * @type {string}
     * @memberof SleepToolConfig
     */
    'type'?: SleepToolConfigTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SleepToolConfig
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SleepToolConfig
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SleepToolConfig
     */
    'input_schema'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof SleepToolConfig
     */
    'output_type'?: SleepToolConfigOutputTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SleepToolConfig
     */
    'output_schema'?: { [key: string]: any; };
}

export const SleepToolConfigTypeEnum = {
    SLEEP: 'sleep'
} as const;

export type SleepToolConfigTypeEnum = typeof SleepToolConfigTypeEnum[keyof typeof SleepToolConfigTypeEnum];
export const SleepToolConfigOutputTypeEnum = {
    JSON: 'json'
} as const;

export type SleepToolConfigOutputTypeEnum = typeof SleepToolConfigOutputTypeEnum[keyof typeof SleepToolConfigOutputTypeEnum];

/**
 * Message in OpenAI chat completion format.
 * @export
 * @interface SrcSchemasPublicSchemasChatMessage
 */
export interface SrcSchemasPublicSchemasChatMessage {
    /**
     * 
     * @type {string}
     * @memberof SrcSchemasPublicSchemasChatMessage
     */
    'role': SrcSchemasPublicSchemasChatMessageRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof SrcSchemasPublicSchemasChatMessage
     */
    'content': string;
}

export const SrcSchemasPublicSchemasChatMessageRoleEnum = {
    SYSTEM: 'system',
    USER: 'user',
    ASSISTANT: 'assistant'
} as const;

export type SrcSchemasPublicSchemasChatMessageRoleEnum = typeof SrcSchemasPublicSchemasChatMessageRoleEnum[keyof typeof SrcSchemasPublicSchemasChatMessageRoleEnum];

/**
 * Message for priming AI behavior.  The system message is usually passed in as the first of a sequence of input messages.  Example:     ```python     from langchain_core.messages import HumanMessage, SystemMessage      messages = [         SystemMessage(content=\"You are a helpful assistant! Your name is Bob.\"),         HumanMessage(content=\"What is your name?\"),     ]      # Define a chat model and invoke it with the messages     print(model.invoke(messages))     ```
 * @export
 * @interface SystemMessage
 */
export interface SystemMessage {
    [key: string]: any;

    /**
     * 
     * @type {Content}
     * @memberof SystemMessage
     */
    'content': Content;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SystemMessage
     */
    'additional_kwargs'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SystemMessage
     */
    'response_metadata'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof SystemMessage
     */
    'type'?: string;
    /**
     * 
     * @type {Name}
     * @memberof SystemMessage
     */
    'name'?: Name;
    /**
     * 
     * @type {string}
     * @memberof SystemMessage
     */
    'id'?: string;
}
/**
 * System Message chunk.
 * @export
 * @interface SystemMessageChunk
 */
export interface SystemMessageChunk {
    [key: string]: any;

    /**
     * 
     * @type {Content}
     * @memberof SystemMessageChunk
     */
    'content': Content;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SystemMessageChunk
     */
    'additional_kwargs'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SystemMessageChunk
     */
    'response_metadata'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof SystemMessageChunk
     */
    'type'?: string;
    /**
     * 
     * @type {Name}
     * @memberof SystemMessageChunk
     */
    'name'?: Name;
    /**
     * 
     * @type {string}
     * @memberof SystemMessageChunk
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TerminationReason = {
    EXPIRED: 'expired',
    INVOCATION_RUNTIME_LIMIT: 'invocation_runtime_limit',
    MODEL_CALL_LIMIT: 'model_call_limit',
    TOOL_CALL_LIMIT: 'tool_call_limit',
    INFINITE_TOOL_LOOP: 'infinite_tool_loop',
    ERROR: 'error',
    USER_CANCELLED: 'user_cancelled',
    UPSTREAM_CANCELLED: 'upstream_cancelled',
    VERSION_DIVERGED: 'version_diverged'
} as const;

export type TerminationReason = typeof TerminationReason[keyof typeof TerminationReason];


/**
 * When triggered from a test run.
 * @export
 * @interface TestRunTrigger
 */
export interface TestRunTrigger {
    /**
     * 
     * @type {string}
     * @memberof TestRunTrigger
     */
    'source_type'?: TestRunTriggerSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TestRunTrigger
     */
    'test_run_id': string;
}

export const TestRunTriggerSourceTypeEnum = {
    TEST_RUN: 'test_run'
} as const;

export type TestRunTriggerSourceTypeEnum = typeof TestRunTriggerSourceTypeEnum[keyof typeof TestRunTriggerSourceTypeEnum];

/**
 * Represents an AI\'s request to call a tool.  Example:     ```python     {\"name\": \"foo\", \"args\": {\"a\": 1}, \"id\": \"123\"}     ```      This represents a request to call the tool named `\'foo\'` with arguments     `{\"a\": 1}` and an identifier of `\'123\'`.
 * @export
 * @interface ToolCall
 */
export interface ToolCall {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ToolCall
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ToolCall
     */
    'args': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ToolCall
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ToolCall
     */
    'type'?: string;
}
/**
 * A chunk of a tool call (yielded when streaming).  When merging `ToolCallChunk`s (e.g., via `AIMessageChunk.__add__`), all string attributes are concatenated. Chunks are only merged if their values of `index` are equal and not None.  Example: ```python left_chunks = [ToolCallChunk(name=\"foo\", args=\'{\"a\":\', index=0)] right_chunks = [ToolCallChunk(name=None, args=\"1}\", index=0)]  (     AIMessageChunk(content=\"\", tool_call_chunks=left_chunks)     + AIMessageChunk(content=\"\", tool_call_chunks=right_chunks) ).tool_call_chunks == [ToolCallChunk(name=\"foo\", args=\'{\"a\":1}\', index=0)] ```
 * @export
 * @interface ToolCallChunk
 */
export interface ToolCallChunk {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ToolCallChunk
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ToolCallChunk
     */
    'args': string | null;
    /**
     * 
     * @type {string}
     * @memberof ToolCallChunk
     */
    'id': string | null;
    /**
     * 
     * @type {number}
     * @memberof ToolCallChunk
     */
    'index': number | null;
    /**
     * 
     * @type {string}
     * @memberof ToolCallChunk
     */
    'type'?: ToolCallChunkTypeEnum;
}

export const ToolCallChunkTypeEnum = {
    TOOL_CALL_CHUNK: 'tool_call_chunk'
} as const;

export type ToolCallChunkTypeEnum = typeof ToolCallChunkTypeEnum[keyof typeof ToolCallChunkTypeEnum];

/**
 * Message for passing the result of executing a tool back to a model.  `ToolMessage` objects contain the result of a tool invocation. Typically, the result is encoded inside the `content` field.  `tool_call_id` is used to associate the tool call request with the tool call response. Useful in situations where a chat model is able to request multiple tool calls in parallel.  Example:     A `ToolMessage` representing a result of `42` from a tool call with id      ```python     from langchain_core.messages import ToolMessage      ToolMessage(content=\"42\", tool_call_id=\"call_Jja7J89XsjrOLA5r!MEOW!SL\")     ```  Example:     A `ToolMessage` where only part of the tool output is sent to the model     and the full output is passed in to artifact.      ```python     from langchain_core.messages import ToolMessage      tool_output = {         \"stdout\": \"From the graph we can see that the correlation between \"         \"x and y is ...\",         \"stderr\": None,         \"artifacts\": {\"type\": \"image\", \"base64_data\": \"/9j/4gIcSU...\"},     }      ToolMessage(         content=tool_output[\"stdout\"],         artifact=tool_output,         tool_call_id=\"call_Jja7J89XsjrOLA5r!MEOW!SL\",     )     ```
 * @export
 * @interface ToolMessage
 */
export interface ToolMessage {
    [key: string]: any;

    /**
     * 
     * @type {Content}
     * @memberof ToolMessage
     */
    'content': Content;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ToolMessage
     */
    'additional_kwargs'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ToolMessage
     */
    'response_metadata'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ToolMessage
     */
    'type'?: string;
    /**
     * 
     * @type {Name}
     * @memberof ToolMessage
     */
    'name'?: Name;
    /**
     * 
     * @type {string}
     * @memberof ToolMessage
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToolMessage
     */
    'tool_call_id': string;
    /**
     * 
     * @type {any}
     * @memberof ToolMessage
     */
    'artifact'?: any;
    /**
     * 
     * @type {string}
     * @memberof ToolMessage
     */
    'status'?: ToolMessageStatusEnum;
}

export const ToolMessageStatusEnum = {
    SUCCESS: 'success',
    ERROR: 'error'
} as const;

export type ToolMessageStatusEnum = typeof ToolMessageStatusEnum[keyof typeof ToolMessageStatusEnum];

/**
 * Tool Message chunk.
 * @export
 * @interface ToolMessageChunk
 */
export interface ToolMessageChunk {
    [key: string]: any;

    /**
     * 
     * @type {Content}
     * @memberof ToolMessageChunk
     */
    'content': Content;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ToolMessageChunk
     */
    'additional_kwargs'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ToolMessageChunk
     */
    'response_metadata'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ToolMessageChunk
     */
    'type'?: string;
    /**
     * 
     * @type {Name}
     * @memberof ToolMessageChunk
     */
    'name'?: Name;
    /**
     * 
     * @type {string}
     * @memberof ToolMessageChunk
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToolMessageChunk
     */
    'tool_call_id': string;
    /**
     * 
     * @type {any}
     * @memberof ToolMessageChunk
     */
    'artifact'?: any;
    /**
     * 
     * @type {string}
     * @memberof ToolMessageChunk
     */
    'status'?: ToolMessageChunkStatusEnum;
}

export const ToolMessageChunkStatusEnum = {
    SUCCESS: 'success',
    ERROR: 'error'
} as const;

export type ToolMessageChunkStatusEnum = typeof ToolMessageChunkStatusEnum[keyof typeof ToolMessageChunkStatusEnum];

/**
 * @type Trigger
 * @export
 */
export type Trigger = { source_type: 'api' } & ApiTrigger | { source_type: 'case' } & CaseTrigger | { source_type: 'flow' } & FlowTrigger | { source_type: 'playground' } & PlaygroundTrigger | { source_type: 'test_run' } & TestRunTrigger;

/**
 * Usage metadata for a message, such as token counts.  This is a standard representation of token usage that is consistent across models.  Example:     ```python     {         \"input_tokens\": 350,         \"output_tokens\": 240,         \"total_tokens\": 590,         \"input_token_details\": {             \"audio\": 10,             \"cache_creation\": 200,             \"cache_read\": 100,         },         \"output_token_details\": {             \"audio\": 10,             \"reasoning\": 200,         },     }     ```  !!! warning \"Behavior changed in `langchain-core` 0.3.9\"      Added `input_token_details` and `output_token_details`.  !!! note \"LangSmith SDK\"      The LangSmith SDK also has a `UsageMetadata` class. While the two share fields,     LangSmith\'s `UsageMetadata` has additional fields to capture cost information     used by the LangSmith platform.
 * @export
 * @interface UsageMetadata
 */
export interface UsageMetadata {
    [key: string]: any;

    /**
     * 
     * @type {number}
     * @memberof UsageMetadata
     */
    'input_tokens': number;
    /**
     * 
     * @type {number}
     * @memberof UsageMetadata
     */
    'output_tokens': number;
    /**
     * 
     * @type {number}
     * @memberof UsageMetadata
     */
    'total_tokens': number;
    /**
     * 
     * @type {InputTokenDetails}
     * @memberof UsageMetadata
     */
    'input_token_details'?: InputTokenDetails;
    /**
     * 
     * @type {OutputTokenDetails}
     * @memberof UsageMetadata
     */
    'output_token_details'?: OutputTokenDetails;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * AgentExecutionApi - axios parameter creator
 * @export
 */
export const AgentExecutionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get session details.  Results are included only for sessions with SUCCESS status. Messages are included regardless of status when include_messages=True.
         * @summary Get Session
         * @param {string} sessionId 
         * @param {boolean} [includeMessages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionAgentsManagementApiV0SessionsSessionIdGet: async (sessionId: string, includeMessages?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getSessionAgentsManagementApiV0SessionsSessionIdGet', 'sessionId', sessionId)
            const localVarPath = `/agents/management/api/v0/sessions/{session_id}`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (includeMessages !== undefined) {
                localVarQueryParameter['include_messages'] = includeMessages;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invoke an AI agent with the given prompt and configuration.  Transforms and forwards the invocation request to Agent Runner.
         * @summary Invoke Agent
         * @param {Data} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invokeAgentAgentsManagementApiV0InvokePost: async (data: Data, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'data' is not null or undefined
            assertParamExists('invokeAgentAgentsManagementApiV0InvokePost', 'data', data)
            const localVarPath = `/agents/management/api/v0/invoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invoke an AI agent from the playground (pre-warmed via ping).  Uses a deterministic AgentCore runtimeSessionId per playground session for routing, and a separate internal session ID for proper session isolation. This means that each playground session gets its own warm container.
         * @summary Playground Invoke Agent
         * @param {AgentPlaygroundInvokeRequest} agentPlaygroundInvokeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost: async (agentPlaygroundInvokeRequest: AgentPlaygroundInvokeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentPlaygroundInvokeRequest' is not null or undefined
            assertParamExists('playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost', 'agentPlaygroundInvokeRequest', agentPlaygroundInvokeRequest)
            const localVarPath = `/agents/management/api/v0/playground/invoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentPlaygroundInvokeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pre-warm an AgentCore container for playground invocations.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session.  Use this when user opens the playground UI to reduce latency on first actual invocation.
         * @summary Playground Ping
         * @param {PlaygroundPingRequest} playgroundPingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playgroundPingAgentsManagementApiV0PlaygroundPingPost: async (playgroundPingRequest: PlaygroundPingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playgroundPingRequest' is not null or undefined
            assertParamExists('playgroundPingAgentsManagementApiV0PlaygroundPingPost', 'playgroundPingRequest', playgroundPingRequest)
            const localVarPath = `/agents/management/api/v0/playground/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(playgroundPingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentExecutionApi - functional programming interface
 * @export
 */
export const AgentExecutionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentExecutionApiAxiosParamCreator(configuration)
    return {
        /**
         * Get session details.  Results are included only for sessions with SUCCESS status. Messages are included regardless of status when include_messages=True.
         * @summary Get Session
         * @param {string} sessionId 
         * @param {boolean} [includeMessages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionAgentsManagementApiV0SessionsSessionIdGet(sessionId: string, includeMessages?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionAgentsManagementApiV0SessionsSessionIdGet(sessionId, includeMessages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.getSessionAgentsManagementApiV0SessionsSessionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invoke an AI agent with the given prompt and configuration.  Transforms and forwards the invocation request to Agent Runner.
         * @summary Invoke Agent
         * @param {Data} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invokeAgentAgentsManagementApiV0InvokePost(data: Data, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentInvokeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invokeAgentAgentsManagementApiV0InvokePost(data, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.invokeAgentAgentsManagementApiV0InvokePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invoke an AI agent from the playground (pre-warmed via ping).  Uses a deterministic AgentCore runtimeSessionId per playground session for routing, and a separate internal session ID for proper session isolation. This means that each playground session gets its own warm container.
         * @summary Playground Invoke Agent
         * @param {AgentPlaygroundInvokeRequest} agentPlaygroundInvokeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost(agentPlaygroundInvokeRequest: AgentPlaygroundInvokeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentInvokeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost(agentPlaygroundInvokeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pre-warm an AgentCore container for playground invocations.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session.  Use this when user opens the playground UI to reduce latency on first actual invocation.
         * @summary Playground Ping
         * @param {PlaygroundPingRequest} playgroundPingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playgroundPingAgentsManagementApiV0PlaygroundPingPost(playgroundPingRequest: PlaygroundPingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaygroundPingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playgroundPingAgentsManagementApiV0PlaygroundPingPost(playgroundPingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentExecutionApi.playgroundPingAgentsManagementApiV0PlaygroundPingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgentExecutionApi - factory interface
 * @export
 */
export const AgentExecutionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentExecutionApiFp(configuration)
    return {
        /**
         * Get session details.  Results are included only for sessions with SUCCESS status. Messages are included regardless of status when include_messages=True.
         * @summary Get Session
         * @param {AgentExecutionApiGetSessionAgentsManagementApiV0SessionsSessionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionAgentsManagementApiV0SessionsSessionIdGet(requestParameters: AgentExecutionApiGetSessionAgentsManagementApiV0SessionsSessionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionResponse> {
            return localVarFp.getSessionAgentsManagementApiV0SessionsSessionIdGet(requestParameters.sessionId, requestParameters.includeMessages, options).then((request) => request(axios, basePath));
        },
        /**
         * Invoke an AI agent with the given prompt and configuration.  Transforms and forwards the invocation request to Agent Runner.
         * @summary Invoke Agent
         * @param {AgentExecutionApiInvokeAgentAgentsManagementApiV0InvokePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invokeAgentAgentsManagementApiV0InvokePost(requestParameters: AgentExecutionApiInvokeAgentAgentsManagementApiV0InvokePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentInvokeResponse> {
            return localVarFp.invokeAgentAgentsManagementApiV0InvokePost(requestParameters.data, options).then((request) => request(axios, basePath));
        },
        /**
         * Invoke an AI agent from the playground (pre-warmed via ping).  Uses a deterministic AgentCore runtimeSessionId per playground session for routing, and a separate internal session ID for proper session isolation. This means that each playground session gets its own warm container.
         * @summary Playground Invoke Agent
         * @param {AgentExecutionApiPlaygroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost(requestParameters: AgentExecutionApiPlaygroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentInvokeResponse> {
            return localVarFp.playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost(requestParameters.agentPlaygroundInvokeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Pre-warm an AgentCore container for playground invocations.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session.  Use this when user opens the playground UI to reduce latency on first actual invocation.
         * @summary Playground Ping
         * @param {AgentExecutionApiPlaygroundPingAgentsManagementApiV0PlaygroundPingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playgroundPingAgentsManagementApiV0PlaygroundPingPost(requestParameters: AgentExecutionApiPlaygroundPingAgentsManagementApiV0PlaygroundPingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlaygroundPingResponse> {
            return localVarFp.playgroundPingAgentsManagementApiV0PlaygroundPingPost(requestParameters.playgroundPingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getSessionAgentsManagementApiV0SessionsSessionIdGet operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiGetSessionAgentsManagementApiV0SessionsSessionIdGetRequest
 */
export interface AgentExecutionApiGetSessionAgentsManagementApiV0SessionsSessionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentExecutionApiGetSessionAgentsManagementApiV0SessionsSessionIdGet
     */
    readonly sessionId: string

    /**
     * 
     * @type {boolean}
     * @memberof AgentExecutionApiGetSessionAgentsManagementApiV0SessionsSessionIdGet
     */
    readonly includeMessages?: boolean
}

/**
 * Request parameters for invokeAgentAgentsManagementApiV0InvokePost operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiInvokeAgentAgentsManagementApiV0InvokePostRequest
 */
export interface AgentExecutionApiInvokeAgentAgentsManagementApiV0InvokePostRequest {
    /**
     * 
     * @type {Data}
     * @memberof AgentExecutionApiInvokeAgentAgentsManagementApiV0InvokePost
     */
    readonly data: Data
}

/**
 * Request parameters for playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiPlaygroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePostRequest
 */
export interface AgentExecutionApiPlaygroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePostRequest {
    /**
     * 
     * @type {AgentPlaygroundInvokeRequest}
     * @memberof AgentExecutionApiPlaygroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost
     */
    readonly agentPlaygroundInvokeRequest: AgentPlaygroundInvokeRequest
}

/**
 * Request parameters for playgroundPingAgentsManagementApiV0PlaygroundPingPost operation in AgentExecutionApi.
 * @export
 * @interface AgentExecutionApiPlaygroundPingAgentsManagementApiV0PlaygroundPingPostRequest
 */
export interface AgentExecutionApiPlaygroundPingAgentsManagementApiV0PlaygroundPingPostRequest {
    /**
     * 
     * @type {PlaygroundPingRequest}
     * @memberof AgentExecutionApiPlaygroundPingAgentsManagementApiV0PlaygroundPingPost
     */
    readonly playgroundPingRequest: PlaygroundPingRequest
}

/**
 * AgentExecutionApi - object-oriented interface
 * @export
 * @class AgentExecutionApi
 * @extends {BaseAPI}
 */
export class AgentExecutionApi extends BaseAPI {
    /**
     * Get session details.  Results are included only for sessions with SUCCESS status. Messages are included regardless of status when include_messages=True.
     * @summary Get Session
     * @param {AgentExecutionApiGetSessionAgentsManagementApiV0SessionsSessionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public getSessionAgentsManagementApiV0SessionsSessionIdGet(requestParameters: AgentExecutionApiGetSessionAgentsManagementApiV0SessionsSessionIdGetRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).getSessionAgentsManagementApiV0SessionsSessionIdGet(requestParameters.sessionId, requestParameters.includeMessages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invoke an AI agent with the given prompt and configuration.  Transforms and forwards the invocation request to Agent Runner.
     * @summary Invoke Agent
     * @param {AgentExecutionApiInvokeAgentAgentsManagementApiV0InvokePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public invokeAgentAgentsManagementApiV0InvokePost(requestParameters: AgentExecutionApiInvokeAgentAgentsManagementApiV0InvokePostRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).invokeAgentAgentsManagementApiV0InvokePost(requestParameters.data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invoke an AI agent from the playground (pre-warmed via ping).  Uses a deterministic AgentCore runtimeSessionId per playground session for routing, and a separate internal session ID for proper session isolation. This means that each playground session gets its own warm container.
     * @summary Playground Invoke Agent
     * @param {AgentExecutionApiPlaygroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost(requestParameters: AgentExecutionApiPlaygroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePostRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).playgroundInvokeAgentAgentsManagementApiV0PlaygroundInvokePost(requestParameters.agentPlaygroundInvokeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pre-warm an AgentCore container for playground invocations.  Sends a lightweight ping request to AgentCore to start a container for the specified agent version. The runner detects this as a ping and returns immediately without creating a session.  Use this when user opens the playground UI to reduce latency on first actual invocation.
     * @summary Playground Ping
     * @param {AgentExecutionApiPlaygroundPingAgentsManagementApiV0PlaygroundPingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentExecutionApi
     */
    public playgroundPingAgentsManagementApiV0PlaygroundPingPost(requestParameters: AgentExecutionApiPlaygroundPingAgentsManagementApiV0PlaygroundPingPostRequest, options?: RawAxiosRequestConfig) {
        return AgentExecutionApiFp(this.configuration).playgroundPingAgentsManagementApiV0PlaygroundPingPost(requestParameters.playgroundPingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AgentManagementApi - axios parameter creator
 * @export
 */
export const AgentManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new agent.  Raises:     409: If an agent with the slug already exists
         * @summary Create Agent
         * @param {AgentCreate} agentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentAgentsManagementApiV0AgentsPost: async (agentCreate: AgentCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentCreate' is not null or undefined
            assertParamExists('createAgentAgentsManagementApiV0AgentsPost', 'agentCreate', agentCreate)
            const localVarPath = `/agents/management/api/v0/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new draft version.  Either configuration or source_version_id must be provided in the request body. If source_version_id is provided, the configuration will be copied from that version.  Raises:     404: If the agent or source version is not found     409: If a version with the same name already exists
         * @summary Create Version
         * @param {string} agentId 
         * @param {AgentVersionCreate} agentVersionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost: async (agentId: string, agentVersionCreate: AgentVersionCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost', 'agentId', agentId)
            // verify required parameter 'agentVersionCreate' is not null or undefined
            assertParamExists('createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost', 'agentVersionCreate', agentVersionCreate)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}/versions`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentVersionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an agent.  Only allowed if all versions are drafts.  Raises:     404: If the agent is not found
         * @summary Delete Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentAgentsManagementApiV0AgentsAgentIdDelete: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('deleteAgentAgentsManagementApiV0AgentsAgentIdDelete', 'agentId', agentId)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an agent version.  Only draft versions can be deleted.  Raises:     404: If the agent or version is not found     409: If the version is published or in use
         * @summary Delete Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete: async (agentId: string, versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete', 'agentId', agentId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete', 'versionId', versionId)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}/versions/{version_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an agent by ID.  Returns:     Agent with latest published version ID  Raises:     404: If the agent is not found
         * @summary Get Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentAgentsManagementApiV0AgentsAgentIdGet: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAgentAgentsManagementApiV0AgentsAgentIdGet', 'agentId', agentId)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific agent version.  Raises:     404: If the agent or version is not found
         * @summary Get Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet: async (agentId: string, versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet', 'agentId', agentId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet', 'versionId', versionId)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}/versions/{version_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List agents, optionally filtered by folder.
         * @summary List Agents
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgentsAgentsManagementApiV0AgentsGet: async (folderId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agents/management/api/v0/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List versions for an agent.
         * @summary List Versions
         * @param {string} agentId 
         * @param {AgentVersionStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet: async (agentId: string, status?: AgentVersionStatus | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet', 'agentId', agentId)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}/versions`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Publish a draft version.  Raises:     404: If the agent or version is not found     409: If the version is already published     412: If etag does not match
         * @summary Publish Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {string} ifMatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost: async (agentId: string, versionId: string, ifMatch: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost', 'agentId', agentId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost', 'versionId', versionId)
            // verify required parameter 'ifMatch' is not null or undefined
            assertParamExists('publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost', 'ifMatch', ifMatch)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}/versions/{version_id}/publish`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an agent\'s metadata.  Raises:     404: If the agent is not found
         * @summary Update Agent
         * @param {string} agentId 
         * @param {AgentUpdate} agentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentAgentsManagementApiV0AgentsAgentIdPut: async (agentId: string, agentUpdate: AgentUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateAgentAgentsManagementApiV0AgentsAgentIdPut', 'agentId', agentId)
            // verify required parameter 'agentUpdate' is not null or undefined
            assertParamExists('updateAgentAgentsManagementApiV0AgentsAgentIdPut', 'agentUpdate', agentUpdate)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an agent version\'s name, description, and configuration.  Can only update draft versions. To publish a version, use the publish endpoint.  Raises:     404: If the agent or version is not found     409: If the version is already published or name already exists     412: If etag does not match
         * @summary Update Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {string} ifMatch 
         * @param {AgentVersionUpdate} agentVersionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut: async (agentId: string, versionId: string, ifMatch: string, agentVersionUpdate: AgentVersionUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut', 'agentId', agentId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut', 'versionId', versionId)
            // verify required parameter 'ifMatch' is not null or undefined
            assertParamExists('updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut', 'ifMatch', ifMatch)
            // verify required parameter 'agentVersionUpdate' is not null or undefined
            assertParamExists('updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut', 'agentVersionUpdate', agentVersionUpdate)
            const localVarPath = `/agents/management/api/v0/agents/{agent_id}/versions/{version_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentVersionUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentManagementApi - functional programming interface
 * @export
 */
export const AgentManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new agent.  Raises:     409: If an agent with the slug already exists
         * @summary Create Agent
         * @param {AgentCreate} agentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgentAgentsManagementApiV0AgentsPost(agentCreate: AgentCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgentAgentsManagementApiV0AgentsPost(agentCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.createAgentAgentsManagementApiV0AgentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new draft version.  Either configuration or source_version_id must be provided in the request body. If source_version_id is provided, the configuration will be copied from that version.  Raises:     404: If the agent or source version is not found     409: If a version with the same name already exists
         * @summary Create Version
         * @param {string} agentId 
         * @param {AgentVersionCreate} agentVersionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost(agentId: string, agentVersionCreate: AgentVersionCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost(agentId, agentVersionCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an agent.  Only allowed if all versions are drafts.  Raises:     404: If the agent is not found
         * @summary Delete Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgentAgentsManagementApiV0AgentsAgentIdDelete(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgentAgentsManagementApiV0AgentsAgentIdDelete(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.deleteAgentAgentsManagementApiV0AgentsAgentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an agent version.  Only draft versions can be deleted.  Raises:     404: If the agent or version is not found     409: If the version is published or in use
         * @summary Delete Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(agentId: string, versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(agentId, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get an agent by ID.  Returns:     Agent with latest published version ID  Raises:     404: If the agent is not found
         * @summary Get Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentAgentsManagementApiV0AgentsAgentIdGet(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentGetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentAgentsManagementApiV0AgentsAgentIdGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.getAgentAgentsManagementApiV0AgentsAgentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific agent version.  Raises:     404: If the agent or version is not found
         * @summary Get Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet(agentId: string, versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet(agentId, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List agents, optionally filtered by folder.
         * @summary List Agents
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAgentsAgentsManagementApiV0AgentsGet(folderId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAgentsAgentsManagementApiV0AgentsGet(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.listAgentsAgentsManagementApiV0AgentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List versions for an agent.
         * @summary List Versions
         * @param {string} agentId 
         * @param {AgentVersionStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet(agentId: string, status?: AgentVersionStatus | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet(agentId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Publish a draft version.  Raises:     404: If the agent or version is not found     409: If the version is already published     412: If etag does not match
         * @summary Publish Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {string} ifMatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(agentId: string, versionId: string, ifMatch: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(agentId, versionId, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an agent\'s metadata.  Raises:     404: If the agent is not found
         * @summary Update Agent
         * @param {string} agentId 
         * @param {AgentUpdate} agentUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgentAgentsManagementApiV0AgentsAgentIdPut(agentId: string, agentUpdate: AgentUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgentAgentsManagementApiV0AgentsAgentIdPut(agentId, agentUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.updateAgentAgentsManagementApiV0AgentsAgentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an agent version\'s name, description, and configuration.  Can only update draft versions. To publish a version, use the publish endpoint.  Raises:     404: If the agent or version is not found     409: If the version is already published or name already exists     412: If etag does not match
         * @summary Update Version
         * @param {string} agentId 
         * @param {string} versionId 
         * @param {string} ifMatch 
         * @param {AgentVersionUpdate} agentVersionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut(agentId: string, versionId: string, ifMatch: string, agentVersionUpdate: AgentVersionUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut(agentId, versionId, ifMatch, agentVersionUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentManagementApi.updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgentManagementApi - factory interface
 * @export
 */
export const AgentManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentManagementApiFp(configuration)
    return {
        /**
         * Create a new agent.  Raises:     409: If an agent with the slug already exists
         * @summary Create Agent
         * @param {AgentManagementApiCreateAgentAgentsManagementApiV0AgentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentAgentsManagementApiV0AgentsPost(requestParameters: AgentManagementApiCreateAgentAgentsManagementApiV0AgentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentCreateResponse> {
            return localVarFp.createAgentAgentsManagementApiV0AgentsPost(requestParameters.agentCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new draft version.  Either configuration or source_version_id must be provided in the request body. If source_version_id is provided, the configuration will be copied from that version.  Raises:     404: If the agent or source version is not found     409: If a version with the same name already exists
         * @summary Create Version
         * @param {AgentManagementApiCreateVersionAgentsManagementApiV0AgentsAgentIdVersionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost(requestParameters: AgentManagementApiCreateVersionAgentsManagementApiV0AgentsAgentIdVersionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionResponse> {
            return localVarFp.createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost(requestParameters.agentId, requestParameters.agentVersionCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an agent.  Only allowed if all versions are drafts.  Raises:     404: If the agent is not found
         * @summary Delete Agent
         * @param {AgentManagementApiDeleteAgentAgentsManagementApiV0AgentsAgentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentAgentsManagementApiV0AgentsAgentIdDelete(requestParameters: AgentManagementApiDeleteAgentAgentsManagementApiV0AgentsAgentIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAgentAgentsManagementApiV0AgentsAgentIdDelete(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an agent version.  Only draft versions can be deleted.  Raises:     404: If the agent or version is not found     409: If the version is published or in use
         * @summary Delete Version
         * @param {AgentManagementApiDeleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(requestParameters: AgentManagementApiDeleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(requestParameters.agentId, requestParameters.versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get an agent by ID.  Returns:     Agent with latest published version ID  Raises:     404: If the agent is not found
         * @summary Get Agent
         * @param {AgentManagementApiGetAgentAgentsManagementApiV0AgentsAgentIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentAgentsManagementApiV0AgentsAgentIdGet(requestParameters: AgentManagementApiGetAgentAgentsManagementApiV0AgentsAgentIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentGetResponse> {
            return localVarFp.getAgentAgentsManagementApiV0AgentsAgentIdGet(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific agent version.  Raises:     404: If the agent or version is not found
         * @summary Get Version
         * @param {AgentManagementApiGetVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet(requestParameters: AgentManagementApiGetVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionResponse> {
            return localVarFp.getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet(requestParameters.agentId, requestParameters.versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * List agents, optionally filtered by folder.
         * @summary List Agents
         * @param {AgentManagementApiListAgentsAgentsManagementApiV0AgentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgentsAgentsManagementApiV0AgentsGet(requestParameters: AgentManagementApiListAgentsAgentsManagementApiV0AgentsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AgentListResponse> {
            return localVarFp.listAgentsAgentsManagementApiV0AgentsGet(requestParameters.folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * List versions for an agent.
         * @summary List Versions
         * @param {AgentManagementApiListVersionsAgentsManagementApiV0AgentsAgentIdVersionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet(requestParameters: AgentManagementApiListVersionsAgentsManagementApiV0AgentsAgentIdVersionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionListResponse> {
            return localVarFp.listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet(requestParameters.agentId, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * Publish a draft version.  Raises:     404: If the agent or version is not found     409: If the version is already published     412: If etag does not match
         * @summary Publish Version
         * @param {AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(requestParameters: AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionResponse> {
            return localVarFp.publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(requestParameters.agentId, requestParameters.versionId, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an agent\'s metadata.  Raises:     404: If the agent is not found
         * @summary Update Agent
         * @param {AgentManagementApiUpdateAgentAgentsManagementApiV0AgentsAgentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentAgentsManagementApiV0AgentsAgentIdPut(requestParameters: AgentManagementApiUpdateAgentAgentsManagementApiV0AgentsAgentIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentUpdateResponse> {
            return localVarFp.updateAgentAgentsManagementApiV0AgentsAgentIdPut(requestParameters.agentId, requestParameters.agentUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an agent version\'s name, description, and configuration.  Can only update draft versions. To publish a version, use the publish endpoint.  Raises:     404: If the agent or version is not found     409: If the version is already published or name already exists     412: If etag does not match
         * @summary Update Version
         * @param {AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut(requestParameters: AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentVersionResponse> {
            return localVarFp.updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut(requestParameters.agentId, requestParameters.versionId, requestParameters.ifMatch, requestParameters.agentVersionUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createAgentAgentsManagementApiV0AgentsPost operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiCreateAgentAgentsManagementApiV0AgentsPostRequest
 */
export interface AgentManagementApiCreateAgentAgentsManagementApiV0AgentsPostRequest {
    /**
     * 
     * @type {AgentCreate}
     * @memberof AgentManagementApiCreateAgentAgentsManagementApiV0AgentsPost
     */
    readonly agentCreate: AgentCreate
}

/**
 * Request parameters for createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiCreateVersionAgentsManagementApiV0AgentsAgentIdVersionsPostRequest
 */
export interface AgentManagementApiCreateVersionAgentsManagementApiV0AgentsAgentIdVersionsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiCreateVersionAgentsManagementApiV0AgentsAgentIdVersionsPost
     */
    readonly agentId: string

    /**
     * 
     * @type {AgentVersionCreate}
     * @memberof AgentManagementApiCreateVersionAgentsManagementApiV0AgentsAgentIdVersionsPost
     */
    readonly agentVersionCreate: AgentVersionCreate
}

/**
 * Request parameters for deleteAgentAgentsManagementApiV0AgentsAgentIdDelete operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiDeleteAgentAgentsManagementApiV0AgentsAgentIdDeleteRequest
 */
export interface AgentManagementApiDeleteAgentAgentsManagementApiV0AgentsAgentIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiDeleteAgentAgentsManagementApiV0AgentsAgentIdDelete
     */
    readonly agentId: string
}

/**
 * Request parameters for deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiDeleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest
 */
export interface AgentManagementApiDeleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiDeleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete
     */
    readonly agentId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiDeleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete
     */
    readonly versionId: string
}

/**
 * Request parameters for getAgentAgentsManagementApiV0AgentsAgentIdGet operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiGetAgentAgentsManagementApiV0AgentsAgentIdGetRequest
 */
export interface AgentManagementApiGetAgentAgentsManagementApiV0AgentsAgentIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiGetAgentAgentsManagementApiV0AgentsAgentIdGet
     */
    readonly agentId: string
}

/**
 * Request parameters for getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiGetVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest
 */
export interface AgentManagementApiGetVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiGetVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet
     */
    readonly agentId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiGetVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet
     */
    readonly versionId: string
}

/**
 * Request parameters for listAgentsAgentsManagementApiV0AgentsGet operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiListAgentsAgentsManagementApiV0AgentsGetRequest
 */
export interface AgentManagementApiListAgentsAgentsManagementApiV0AgentsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiListAgentsAgentsManagementApiV0AgentsGet
     */
    readonly folderId?: string | null
}

/**
 * Request parameters for listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiListVersionsAgentsManagementApiV0AgentsAgentIdVersionsGetRequest
 */
export interface AgentManagementApiListVersionsAgentsManagementApiV0AgentsAgentIdVersionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiListVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet
     */
    readonly agentId: string

    /**
     * 
     * @type {AgentVersionStatus}
     * @memberof AgentManagementApiListVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet
     */
    readonly status?: AgentVersionStatus | null
}

/**
 * Request parameters for publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest
 */
export interface AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost
     */
    readonly agentId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost
     */
    readonly versionId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost
     */
    readonly ifMatch: string
}

/**
 * Request parameters for updateAgentAgentsManagementApiV0AgentsAgentIdPut operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiUpdateAgentAgentsManagementApiV0AgentsAgentIdPutRequest
 */
export interface AgentManagementApiUpdateAgentAgentsManagementApiV0AgentsAgentIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiUpdateAgentAgentsManagementApiV0AgentsAgentIdPut
     */
    readonly agentId: string

    /**
     * 
     * @type {AgentUpdate}
     * @memberof AgentManagementApiUpdateAgentAgentsManagementApiV0AgentsAgentIdPut
     */
    readonly agentUpdate: AgentUpdate
}

/**
 * Request parameters for updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut operation in AgentManagementApi.
 * @export
 * @interface AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest
 */
export interface AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut
     */
    readonly agentId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut
     */
    readonly versionId: string

    /**
     * 
     * @type {string}
     * @memberof AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut
     */
    readonly ifMatch: string

    /**
     * 
     * @type {AgentVersionUpdate}
     * @memberof AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut
     */
    readonly agentVersionUpdate: AgentVersionUpdate
}

/**
 * AgentManagementApi - object-oriented interface
 * @export
 * @class AgentManagementApi
 * @extends {BaseAPI}
 */
export class AgentManagementApi extends BaseAPI {
    /**
     * Create a new agent.  Raises:     409: If an agent with the slug already exists
     * @summary Create Agent
     * @param {AgentManagementApiCreateAgentAgentsManagementApiV0AgentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public createAgentAgentsManagementApiV0AgentsPost(requestParameters: AgentManagementApiCreateAgentAgentsManagementApiV0AgentsPostRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).createAgentAgentsManagementApiV0AgentsPost(requestParameters.agentCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new draft version.  Either configuration or source_version_id must be provided in the request body. If source_version_id is provided, the configuration will be copied from that version.  Raises:     404: If the agent or source version is not found     409: If a version with the same name already exists
     * @summary Create Version
     * @param {AgentManagementApiCreateVersionAgentsManagementApiV0AgentsAgentIdVersionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost(requestParameters: AgentManagementApiCreateVersionAgentsManagementApiV0AgentsAgentIdVersionsPostRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).createVersionAgentsManagementApiV0AgentsAgentIdVersionsPost(requestParameters.agentId, requestParameters.agentVersionCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an agent.  Only allowed if all versions are drafts.  Raises:     404: If the agent is not found
     * @summary Delete Agent
     * @param {AgentManagementApiDeleteAgentAgentsManagementApiV0AgentsAgentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public deleteAgentAgentsManagementApiV0AgentsAgentIdDelete(requestParameters: AgentManagementApiDeleteAgentAgentsManagementApiV0AgentsAgentIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).deleteAgentAgentsManagementApiV0AgentsAgentIdDelete(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an agent version.  Only draft versions can be deleted.  Raises:     404: If the agent or version is not found     409: If the version is published or in use
     * @summary Delete Version
     * @param {AgentManagementApiDeleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(requestParameters: AgentManagementApiDeleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).deleteVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdDelete(requestParameters.agentId, requestParameters.versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get an agent by ID.  Returns:     Agent with latest published version ID  Raises:     404: If the agent is not found
     * @summary Get Agent
     * @param {AgentManagementApiGetAgentAgentsManagementApiV0AgentsAgentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public getAgentAgentsManagementApiV0AgentsAgentIdGet(requestParameters: AgentManagementApiGetAgentAgentsManagementApiV0AgentsAgentIdGetRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).getAgentAgentsManagementApiV0AgentsAgentIdGet(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific agent version.  Raises:     404: If the agent or version is not found
     * @summary Get Version
     * @param {AgentManagementApiGetVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet(requestParameters: AgentManagementApiGetVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGetRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).getVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdGet(requestParameters.agentId, requestParameters.versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List agents, optionally filtered by folder.
     * @summary List Agents
     * @param {AgentManagementApiListAgentsAgentsManagementApiV0AgentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public listAgentsAgentsManagementApiV0AgentsGet(requestParameters: AgentManagementApiListAgentsAgentsManagementApiV0AgentsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).listAgentsAgentsManagementApiV0AgentsGet(requestParameters.folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List versions for an agent.
     * @summary List Versions
     * @param {AgentManagementApiListVersionsAgentsManagementApiV0AgentsAgentIdVersionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet(requestParameters: AgentManagementApiListVersionsAgentsManagementApiV0AgentsAgentIdVersionsGetRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).listVersionsAgentsManagementApiV0AgentsAgentIdVersionsGet(requestParameters.agentId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Publish a draft version.  Raises:     404: If the agent or version is not found     409: If the version is already published     412: If etag does not match
     * @summary Publish Version
     * @param {AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(requestParameters: AgentManagementApiPublishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPostRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).publishVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPublishPost(requestParameters.agentId, requestParameters.versionId, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an agent\'s metadata.  Raises:     404: If the agent is not found
     * @summary Update Agent
     * @param {AgentManagementApiUpdateAgentAgentsManagementApiV0AgentsAgentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public updateAgentAgentsManagementApiV0AgentsAgentIdPut(requestParameters: AgentManagementApiUpdateAgentAgentsManagementApiV0AgentsAgentIdPutRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).updateAgentAgentsManagementApiV0AgentsAgentIdPut(requestParameters.agentId, requestParameters.agentUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an agent version\'s name, description, and configuration.  Can only update draft versions. To publish a version, use the publish endpoint.  Raises:     404: If the agent or version is not found     409: If the version is already published or name already exists     412: If etag does not match
     * @summary Update Version
     * @param {AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentManagementApi
     */
    public updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut(requestParameters: AgentManagementApiUpdateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPutRequest, options?: RawAxiosRequestConfig) {
        return AgentManagementApiFp(this.configuration).updateVersionAgentsManagementApiV0AgentsAgentIdVersionsVersionIdPut(requestParameters.agentId, requestParameters.versionId, requestParameters.ifMatch, requestParameters.agentVersionUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



